"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _createPaginationItems = _interopRequireDefault(require("./createPaginationItems"));

exports.default = _createPaginationItems.default;